.container {
  user-select: none;
}

.modalFooter {
  gap: 1rem;
}
